import React from "react";
import "../style/market.css";

import graphGreen from "../assets/greengraph.webp";
import graphRed from "../assets/redgraph.webp";

import btc from "../assets/btc.webp";
import eth from "../assets/eth.webp";
import usdt from "../assets/usdt.webp";
import bnb from "../assets/bnb.webp";
import sol from "../assets/solana.webp";
import xrp from "../assets/xrp_new.webp";

export default function MarketSection() {
  const categories = [
    "View All",
    "Metaverse",
    "Entertainment",
    "Energy",
    "NFT",
    "Gaming",
    "Music",
  ];

  const coins = [
    {
      id: 1,
      name: "Bitcoin",
      symbol: "BTC",
      price: "$90,022.64",
      change: "−1.68% to −2.76%",
      changePositive: false,
      marketCap: "Approx. $1.85 trillion",
      graph: graphRed,
      icon: btc,
    },
    {
      id: 2,
      name: "Ethereum",
      symbol: "ETH",
      price: "$3,247",
      change: "+1.81%",
      changePositive: true,
      marketCap: "Approx. $401 Billion",
      graph: graphGreen,
      icon: eth,
    },
    {
      id: 3,
      name: "Tether",
      symbol: "USDT/USD",
      price: "$1.00",
      change: "~0.00% to -0.02%",
      changePositive: false,
      marketCap: "Approx. $110 Billion",
      graph: graphGreen,
      icon: usdt,
    },
    {
      id: 4,
      name: "BNB",
      symbol: "BNB/USD",
      price: "$880.34",
      change: "−3.02%",
      changePositive: false,
      marketCap: "Approx. $132 Billion",
      graph: graphRed,
      icon: bnb,
    },
    {
      id: 5,
      name: "Solana",
      symbol: "SOL",
      price: "$136.38 - $140.09",
      change: "−0.10% to −1.00%",
      changePositive: false,
      marketCap: "Approx. $76.6 Billion",
      graph: graphRed,
      icon: sol,
    },
    {
      id: 6,
      name: "XRP",
      symbol: "XRP",
      price: "$2.21",
      change: "−0.01%",
      changePositive: false,
      marketCap: "$121 Billion",
      graph: graphRed,
      icon: xrp,
    },
  ];

  return (
    <div className="market-container">
      <h1 className="market-title">Market Update</h1>

      {/* Categories */}
      <div className="categories">
        {categories.map((c, i) => (
          <button key={i} className={i === 0 ? "active" : ""}>
            {c}
          </button>
        ))}
        <span className="see-all">See All Coins</span>
      </div>

      {/* Table Header (Desktop only) */}
      <div className="table-wrapper">
        <div className="table-header">
          <span>#</span>
          <span>Name</span>
          <span>Last Price</span>
          <span>24h %</span>
          <span>Market Cap</span>
          <span>Last 7 Days</span>
          <span></span>
        </div>

        <div className="divider" />

        {/* Coin Rows */}
        {coins.map((coin) => (
          <div className="coin-row" key={coin.id}>
            
            {/* TOP (Mobile) */}
            <div className="coin-top">
              <span className="rank">#{coin.id}</span>

              <div className="coin-name">
                <img src={coin.icon} alt={coin.name} />
                <div>
                  <p className="name">{coin.name}</p>
                  <p className="symbol">{coin.symbol}</p>
                </div>
              </div>
            </div>

            {/* DETAILS */}
            <div className="coin-details">
              <div>
                <span className="label">Price</span>
                <span className="price">{coin.price}</span>
              </div>

              <div>
                <span className="label">24h</span>
                <span
                  className={`change ${
                    coin.changePositive ? "green" : "red"
                  }`}
                >
                  {coin.change}
                </span>
              </div>

              <div>
                <span className="label">Market Cap</span>
                <span className="marketcap">{coin.marketCap}</span>
              </div>
            </div>

            {/* BOTTOM */}
            <div className="coin-bottom">
              <div className="graph-box">
                <img src={coin.graph} alt="graph" />
              </div>

              <button className="trade-btn">Trade</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}